// extracted by mini-css-extract-plugin
module.exports = {"link":"TranslatedLink_link__f3sPM","underlined":"TranslatedLink_underlined__FOjd1"};